export default class Image {
  /**
   * This create the Image objet
   * @param  {Object} image A raw image object
   * @return {void}
   */
  constructor(event = null, self) {
    this.self = self;
    this.file = event === null ? null : event.files[0];
    this.preview = event === null ? null : this.createPreview(this.file);
    this.self.display.image = true;
    this.self.display.unloadButton = true;
    this.self.display.cropButton = true;
    this.self.display.crop = false;
  }

  /**
   * Unload the image
   * @return {void}
   */
  unload() {
    this.self.display.unloadButton = false;
    this.self.newImage = undefined;
    this.self.display.image = false;
    this.self.inputLoaded = false;
    this.self.display.cropButton = false;
    this.self.$nextTick(() => {
      this.self.display.image = true;
      this.self.inputLoaded = true;
    });
  }

  /**
   * This create the preview of the image in base64
   * @param  {image} image The image file
   * @return {void}
   */
  createPreview(image) {
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      function () {
        this.show = true;
        this.preview = reader.result;
      }.bind(this),
      false,
    );

    reader.readAsDataURL(image);
  }

  send(name, path) {
    const formData = new FormData();

    formData.append(name, this.file);

    axios
      .post(`${path}`, formData)
      .then((res) => {
        this.self.$swal({
          text: "L'image a été ajoutée avec succès...",
          type: 'success',
        });
        this.self.images = res.data;
      })
      .catch((err) => {
        this.self.$swal({
          text: 'Une erreur est survenue...',
          type: 'error',
        });
      });
  }

  delete(image) {
    axios
      .delete(`/post/image/${image.id}`)
      .then((res) => {
        this.self.$swal({
          text: res.data,
          type: 'success',
        });
        this.self.images.splice(this.self.images.indexOf(image), 1);
      })
      .catch((err) => {
        this.self.$swal({
          text: 'Une erreur est survenue...',
          type: 'error',
        });
      });
  }
}
